// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2LAcV","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3pLfl","obliqueLine":"membershipbadge_obliqueLine__3fp0z"};